import { render, staticRenderFns } from "./courseweek.vue?vue&type=template&id=bf8c237e&scoped=true&"
import script from "./courseweek.vue?vue&type=script&lang=js&"
export * from "./courseweek.vue?vue&type=script&lang=js&"
import style0 from "./courseweek.vue?vue&type=style&index=0&id=bf8c237e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8c237e",
  null
  
)

export default component.exports